export enum FieldType {
  Text = 0,
  Hidden = 1, // Password
  Boolean = 2, // Ignore
  Linked = 3, // Ignore
  URL = 4,
  Email = 5,
  Address = 6,
  Date = 7,
  MonthYear = 8,
  Phone = 9,
  TOTP = 10
}
